/* eslint-disable camelcase */
import React from 'react';
import memoize from 'memoize-one';

import { ActiveDotAttendance, BasicActionBtns, DatatableEmployeeNameAttendance } from '../index';

const columns = memoize((clickHandler = true) => [
  {
    name: 'RUT Y NOMBRE',
    selector: 'name',
    cell: item => <DatatableEmployeeNameAttendance item={item} />,
    sortable: false,
    grow: '2'
  },
  {
    name: 'CENTRO DE COSTO',
    selector: 'cost_center',
    cell: item => {
      return item.cost_center;
    },
    sortable: false,
    grow: '1'
  },
  {
    name: 'FECHA DE HOY',
    selector: 'dates',
    cell: item => {
      return item.dates && item.dates.length > 0 ? item.dates[0] : '';
    },
    sortable: false,
    grow: '1',
    center: false
  },
  {
    name: 'ASISTENCIA INGRESADA',
    selector: 'attendance',
    cell: item => <ActiveDotAttendance item={item} />,
    sortable: false,
    grow: '1',
    center: true
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <BasicActionBtns
        item={item}
        resource="Employee"
        clickHandler={clickHandler}
        withEdit={false}
        withDestroy={false}
        withShow
      />
    ),
    grow: '1',
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    minWidth: '123px'
  }
]);

export default columns;
